import React from "react";

export const useScrollPosition = () => {
  const [scrollPosition, setScrollPosition] = React.useState(window.scrollY);

  React.useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener("scroll", updatePosition);
    return () => window.removeEventListener("scroll", updatePosition);
  }, []);

  return scrollPosition;
};
